import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import SubHeader from './SubHeader';
import TripsList from './TripsList/TripsList';
import TripsMap from './TripsMap/TripsMap';

import './Trips.css';

@withRouter
@inject('translationsStore', 'tripsStore', 'commonStore')
@observer
export default class Trips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      tab: 'list'
    };
  }

  componentDidMount = () => {
  };

  render() {
    const { trips } = this.props.tripsStore;

    return (
      <div className="Trips">
        <SubHeader  onTabChange={tab => this.setState({ tab })} selectedTab={this.state.tab} />
        {this.props.commonStore.loading === false && (
          <div className="TripContainer">{this.state.tab === 'list' ? <TripsList trips={trips} /> : <TripsMap />}</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Trips/Trips.js